export const isNumber = (value: number | string | null | undefined) => {
    return typeof value === 'number';
};
